import React, { useEffect } from 'react';
import CodeEditorComponent from '../components/common/CodeEditor';
import { CourseProvider, useCourse } from '../providers/CourseContext';

// This component acts as a wrapper that initializes the course context with route params
const Coding: React.FC = () => {
  const { loading } = useCourse();

  // Show loading state while fetching data
  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <div className="app">
      <CourseProvider>
        <CodeEditorComponent />
      </CourseProvider>
    </div>
  );
};

export default Coding;
